import { render } from "./Imagetester.vue?vue&type=template&id=353c7fd4"
import script from "./Imagetester.vue?vue&type=script&lang=js"
export * from "./Imagetester.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/tester.cl-planner.com/releases/62689321/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__